/*
 *
 *Recharge widget Customization
 *
 */
var tierPricing = {
  title: "Buy More Save More",
  description: "Introducing Buy More, Save More",
  max_discount: 0, // Maximum discount cap
  tiers: [
    {
      quantity: 2,
      discount: 5,
      discount_type: "percentage",
    },
    {
      quantity: 3,
      discount: 10,
      discount_type: "percentage",
    },
    {
      quantity: 4,
      discount: 15,
      discount_type: "percentage",
    },
  ],
};
tierPricing.tiers.sort((a, b) => a.quantity - b.quantity);

var card_price_HTML_template = jQuery(
  '[data-ele="card-price-skeleton-html"]'
).html();
card_price_HTML_template = jQuery(card_price_HTML_template);

var _generateHTML = function (template, data) {
  var priceFormat = Shopify.isk.global.price;
  var priceFormatWithCurrency = Shopify.isk.global.price_with_currency;

  let tiers = data.tiers;
  const maxQuantity = tiers[tierPricing.tiers.length - 1].quantity;
  let previousWidth = 0;

  // Replace the heading placeholder with the actual description
  let html = template.replace("__heading__", data.description);

  // Create a temporary DOM element to manipulate the template
  let tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // Find the tier discount, tier item, and progress separator elements
  let tierDiscountTemplate = tempDiv.querySelector(
    '[data-type="tier-discount"]'
  );
  let tierItemTemplate = tempDiv.querySelector('[data-type="tier-item"]');

  let tierProgressSeparatorTemplate = tempDiv.querySelector(
    '[data-type="progress-seprator"]'
  );

  const progressSteps = tempDiv.querySelector('[data-ele="progress-steps"]');
  // Generate the tier discounts, items, and separators
  tiers.forEach(function (tier, index) {
    // Calculate the width for the current step
    const stepPercentage = (tier.quantity / maxQuantity) * 100;
    const width = stepPercentage - previousWidth;
    previousWidth = stepPercentage;

    // Clone the template element for each tier
    let newTierDiscount = tierDiscountTemplate.cloneNode(true);
    let newTierItem = tierItemTemplate.cloneNode(true);
    newTierItem.style.width = `${width}%`;
    newTierDiscount.style.width = `${width}%`;

    if (tier.discount_type === "percentage") {
      newTierDiscount.innerHTML = newTierDiscount.innerHTML.replace(
        "__tier_discount__",
        `${tier.discount}%`
      );
    } else {
      var formattedDiscountPrice = priceFormatWithCurrency.replace(
        "0.00",
        tier.discount.toFixed(2)
      );
      newTierDiscount.innerHTML = newTierDiscount.innerHTML.replace(
        "__tier_discount__",
        `${formattedDiscountPrice}`
      );
    }

    // Replace the placeholders with the actual values

    newTierItem.innerHTML = newTierItem.innerHTML.replace(
      "__tier_item__",
      `${tier.quantity}${index === tiers.length - 1 ? "+" : ""}`
    );

    // Append the new elements to their respective containers
    tierDiscountTemplate.parentElement.appendChild(newTierDiscount);
    tierItemTemplate.parentElement.appendChild(newTierItem);

    //Generating Progressbar
    const step = document.createElement("div");
    step.classList.add("progress-step");

    const stepProgress = document.createElement("div");
    stepProgress.classList.add("progress-bar-step");

    step.appendChild(stepProgress);

    step.style.width = `${width}%`;
    progressSteps.appendChild(step);
  });

  // Remove the original template elements from the DOM
  tierDiscountTemplate.remove();
  tierItemTemplate.remove();
  //tierProgressSeparatorTemplate.remove();

  return tempDiv.innerHTML;
};

_updateProgress = function (quantity) {

  let bannerSections = document.querySelectorAll(
    '[data-ele="tier-banner-section"]'
  );

  bannerSections.forEach(function (bannerSection) {
    
    const progressSteps = bannerSection.querySelectorAll(".progress-step");
    const maxQuantity = tierPricing.tiers[tierPricing.tiers.length - 1].quantity;

    progressSteps.forEach((step, index) => {
      const stepProgress = step.querySelector(".progress-bar-step");
      const tier = tierPricing.tiers[index];

      if (tier) {
        const stepStart =
          index === 0
            ? 0
            : (tierPricing.tiers[index - 1].quantity / maxQuantity) * 100;
        const stepEnd = (tier.quantity / maxQuantity) * 100;
        const stepWidth = stepEnd - stepStart;
        const progressPercentage = (quantity / maxQuantity) * 100;

        if (progressPercentage > stepEnd) {
          stepProgress.style.width = "100%";
        } else if (progressPercentage < stepStart) {
          stepProgress.style.width = "0%";
        } else {
          stepProgress.style.width = `${
            ((progressPercentage - stepStart) / stepWidth) * 100
          }%`;
        }
      }
    });
    
  });

  
};

var _renderTierBanner = function () {
  let skeletonTemplate = document.querySelector(
    '[data-ele="tier-banner-skeleton-html"]'
  );

  let bannerSections = document.querySelectorAll(
    '[data-ele="tier-banner-section"]'
  );

  if (skeletonTemplate) {
    let template = skeletonTemplate.innerHTML;
    let finalHTML = _generateHTML(template, tierPricing);

    bannerSections.forEach(function (bannerSection) {
      bannerSection.innerHTML = finalHTML;
    });
  }
};

_renderTierBanner();

var _add_remove_free_shipping = async function () {
  var _free_shipping_apply = false
  let response_data = await fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
  });
  let json = await response_data.json();

  if (typeof json != 'undefined' && typeof json["items"] != 'undefined' && json["items"]) {
    for (let k = 0; k < json["items"].length; k++) {
      let cart_item = json["items"][k];
      if(typeof cart_item.properties._free_shipping != 'undefined' && cart_item.properties._free_shipping == true){
        _free_shipping_apply = true
      }
    }
  }

  if(typeof _free_shipping_apply != 'undefined' && _free_shipping_apply === true){
    fetch('/discount/FREE-SHIPPING')
    .then(response => {
      if (response.ok) {
        // window.location.href = '/discount/FREE-SHIPPING';
        //console.info("FREE SHIPPING Discount applied.");
      } else {
        console.error("Failed to access discount Code");
      }
    })
    .catch(error => console.error("Fetch error:", error));
  }else{
     fetch('/discount/CLEAR')
    .then(response => {
      if (response.ok) {
        // window.location.href = '/discount/FREE-SHIPPING';
        // console.info("FREE SHIPPING Removed.");
      } else {
        console.error("Failed to access discount code");
      }
    })
    .catch(error => console.error("Fetch error:", error));
  }
}


var _initPrice = async function () {
  var price_containers = jQuery('[data-ele="price_container"]');
  price_containers.addClass('------PRODUTPRICES-----')
  try {
    let response_data = await fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
    });
    let cartData = await response_data.json();

    var qty = 0;
    var cartQTY = 0;

    if (cartData && typeof cartData.item_count != "undefined") {
      cartQTY = cartData.item_count;
    }
    qty = cartQTY;
    
    price_containers.html("");
    price_containers.each(function () {
      var _this = jQuery(this);
      var selectedTier = null;

      var cardBundleSDK =  _this.parents('[data-ele="card-bundle-sdk"]');
      var cardBundleSDK =  _this.parents('[data-ele="card-bundle-sdk"]');

      var disable_price_update = cardBundleSDK.attr('data-ele-disable-price-update-with-bmsm')
      if(typeof disable_price_update != "undefined" && (disable_price_update === true || disable_price_update === 'true')){
        return;
      }

      var bundleItems = cardBundleSDK.attr('data-bundle-items');
      qty = (parseInt(cartQTY) + parseInt(bundleItems));
      
      // Determine the correct tier based on quantity
      for (var i = 0; i < tierPricing.tiers.length; i++) {
        if (qty >= tierPricing.tiers[i].quantity) {
          selectedTier = tierPricing.tiers[i];
        }
      }
      
      var cardMainContainer = _this.parents('.product-card-wrapper');
      var sellingPlanContainer = _this.parents(
        '[data-ele="selling-plan-container"]'
      );
      sellingPlanContainer.find('[data-ele="subscription-frequency-error"]').remove();
      var productInfoContainer = _this.parents(
        'product-info'
      );
      
      var cardSelectedSubscriptionType = sellingPlanContainer
        .find('[data-name="selling_plan"]:checked')
        .val();
      //console.log("cardSelectedSubscriptionType", cardSelectedSubscriptionType);
      var originalSalePrice = parseFloat(_this.attr("data-plan-sale-price"));
      var originalPrice = parseFloat(_this.attr("data-plan-price"));

      var priceContainerType = _this.attr("price-container-type");

      var priceFormat = Shopify.isk.global.price;
      var priceFormatWithCurrency = Shopify.isk.global.price_with_currency;

      if (priceContainerType === "subscription") {
        var subscriptionDropdownSelectedOption = sellingPlanContainer.find(
          '[data-ele="subscription-options"] option:selected'
        );
        originalSalePrice = parseFloat(
          subscriptionDropdownSelectedOption.attr("data-plan-sale-price")
        );
        originalPrice = parseFloat(
          subscriptionDropdownSelectedOption.attr("data-plan-price")
        );
      }

      originalSalePrice = originalSalePrice / 100;
      originalPrice = originalPrice / 100;

      var discountAmount = 0;
      var discountedPrice = originalSalePrice;

      if (selectedTier) {
        if (selectedTier.discount_type === "percentage") {
          discountAmount = originalSalePrice * (selectedTier.discount / 100);
        } else if (selectedTier.discount_type === "fixed") {
          discountAmount = selectedTier.discount;
        }

        // Apply the maximum discount cap
        if (tierPricing.max_discount > 0) {
          discountAmount = Math.min(discountAmount, tierPricing.max_discount);
        }
        // Ensure that the discounted price is not less than zero
        discountedPrice = Math.max(0, originalSalePrice - discountAmount);
      }

      var formattedDiscountPrice = priceFormatWithCurrency.replace(
        "0.00",
        discountedPrice.toFixed(2)
      );

      var formattedOriginalPrice = originalPrice
        ? priceFormat.replace("0.00", originalPrice.toFixed(0))
        : "";

      var formattedOriginalPriceWithCurrency = originalPrice
        ? priceFormatWithCurrency.replace("0.00", originalPrice.toFixed(0))
        : "";
     
      
      if (originalPrice) {
        card_price_HTML_template.find(".price").addClass("price--on-sale");
        card_price_HTML_template
          .find(".price-item--regular")
          .html(formattedOriginalPrice);
        card_price_HTML_template
          .find(".price-item--sale")
          .html(formattedDiscountPrice);
      } else {
        card_price_HTML_template.find(".price").removeClass("price--on-sale");
        card_price_HTML_template
          .find(".price-item--regular")
          .html(formattedDiscountPrice);
      }
      
      _this.html(card_price_HTML_template.html());
      //_this.addClass('============= ============= ============= ============= ============= ')

      //Updating Card Main Price and Product Main Price
      if (originalPrice) {
          card_price_HTML_template
            .find(".price-item--regular")
            .html(formattedOriginalPriceWithCurrency);
      }

      if(priceContainerType == cardSelectedSubscriptionType){
        if(cardMainContainer){
          cardMainContainer.find('.card-information .price').replaceWith(card_price_HTML_template.html());
        }
        if(productInfoContainer){
          productInfoContainer.find('.no-js-hidden .price').replaceWith(card_price_HTML_template.html());
        }
      }

      
    });
    _updateProgress(cartQTY);
  } catch (error) {
    console.error("Error initializing price:", error);
  }
};

_initPrice();

jQuery(document).on("change", '[data-name="selling_plan"]', function () {
  var _this = jQuery(this);
  var subscriptionType = _this.val();
  var subscriptionDropdownEle = _this
    .parents('[data-ele="selling-plan-container"]')
    .find('[data-ele="subscription-options"]');

  var subscriptionSelectEle = _this
    .parents('[data-ele="selling-plan-container"]')
    .find('[data-ele="subscription-select-ele"]');

  if (subscriptionType == "subscription") {
    subscriptionSelectEle.show();
  } else {
    subscriptionSelectEle.hide();
  }
  _this.parents('[data-ele="selling-plan-container"]').find('[data-ele="subscription-frequency-error"]').remove();
  
  _initPrice();
});

jQuery(document).on("change", '[data-ele="subscription-options"]', function () {
  _initPrice();
});

jQuery(document).on(
  "click",
  '[data-ele="selling-plan-container"]:not(.adding) [data-name="add-bundle"]',
  async function () {
    var _this = jQuery(this);
    var subscriptionContainer = _this.parents(
        '[data-ele="selling-plan-container"]'
      );
    
    subscriptionContainer.find('.select-varient-error').remove();
    var validated = true;
    
    var variantRadios = _this.parents('product-info').find('variant-radios');
    if(variantRadios.length){
      validated = false;
      var selectedVariantValue = _this.parents('product-info').find('variant-radios input[type="radio"][name="Flavor"]:checked').val();
      if(typeof selectedVariantValue != 'undefined' && selectedVariantValue){
        validated = true;
      }
    }
    
    if(validated){
      var free_shipping = subscriptionContainer.find('[data-name="free-shipping"]').val();
      var _collectionId = subscriptionContainer
        .find('[data-name="collection-id"]')
        .val();
      var _bundleProductId = subscriptionContainer
        .find('[data-name="bundle-product-id"]')
        .val();
      var _bundleVariantId = subscriptionContainer
        .find('[data-name="bundle-variant-id"]')
        .val();
      
      var _bundleProductHandle = subscriptionContainer
        .find('[data-name="bundle-product-handle"]')
        .val();
  
      var _productId = subscriptionContainer
        .find('[data-name="product-id"]')
        .val();
      var _variantId = subscriptionContainer
        .find('[data-name="variant-id"]')
        .val();
      var _productHandle = subscriptionContainer
        .find('[data-name="product-handle"]')
        .val();
      
       var _selectedSubscriptionValue = subscriptionContainer
        .find('[data-ele="subscription-options"]')
        .val();
  
      var _selectedSubscriptionName = subscriptionContainer
        .find('[data-ele="subscription-options"]')
        .find(":selected")
        .data('plan-name');

      var _selectedSubscriptionGroupId = subscriptionContainer
        .find('[data-ele="subscription-options"]')
        .find(":selected")
        .data('selling-plan-group-id');
  
      var selling_plan_type = subscriptionContainer
        .find('[data-name="selling_plan"]:checked')
        .val();
      
      if (selling_plan_type == "one-time") {
        _selectedSubscriptionValue = "";
      }else{
        if(!_selectedSubscriptionValue || _selectedSubscriptionValue == null){
          _this.after('<p class="select-varient-error" data-ele="subscription-frequency-error">Please select a subscription frequency.</p>');
          return false;
        }
      }
  
      _this.find('[data-ele="response-message"]').html('');
  
      const bundleProductData = {
        productId: _bundleProductId,
        variantId: _bundleVariantId,
        handle: _bundleProductHandle,
        sellingPlan: _selectedSubscriptionValue,
        sellingPlanName: _selectedSubscriptionName,
      };
      //console.log(bundleProductData);
  
      const bundle = {
        externalVariantId: bundleProductData.variantId,
        externalProductId: bundleProductData.productId,
        selections: [
          {
            collectionId: _collectionId,
            externalProductId: _productId,
            externalVariantId: _variantId,
            quantity: 1,
            sellingPlan: bundleProductData.sellingPlan,
          },
        ],
      };
  
      subscriptionContainer.addClass("adding");
      _this.find(".loading-overlay__spinner").removeClass("hidden");
  
      const cartItems = await recharge.bundle.getDynamicBundleItems(
        bundle,
        bundleProductData.handle
      );
      // console.log(cartItems);
      //const cartData = { items: cartItems, sections: ['cart-drawer','cart-icon-bubble'], sections_url: '/collections/supplements', 'product-id':_productId };
      const cartData = {
        items: cartItems,
        sections: ["cart-drawer", "cart-icon-bubble"],
        "product-id": _productId,
      };
  
      let existingBundleId = "";
      let response_data = await fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
      });
      let json = await response_data.json();
  
      if (json["items"]) {
        for (let k = 0; k < json["items"].length; k++) {
          let item = json["items"][k];
          let cartParentBundleName = "";
          let cartBundleId = "";
          let cartSellingPlanName = "";
  
          if (
            "_rc_bundle_parent" in item.properties &&
            "_rc_bundle" in item.properties
          ) {
            cartParentBundleName = item.properties["_rc_bundle_parent"];
            cartBundleId = item.properties["_rc_bundle"];
          }
  
          if (item.selling_plan_allocation) {
            if (
              Object.keys(item.selling_plan_allocation.selling_plan).length > 0
            ) {
              cartSellingPlanName =
                item.selling_plan_allocation.selling_plan.name;
            }
          } else {
            cartSellingPlanName = "One-time purchase";
          }
  
          if (bundleProductData.handle === cartParentBundleName) {
            if (cartSellingPlanName === bundleProductData.sellingPlanName) {
              existingBundleId = cartBundleId;
            }
          }
        }
      }
  
      if (existingBundleId) {
        cartData.items[0].properties._rc_bundle = existingBundleId;
      }
  
      let quantityInput = document.querySelector(
        ".card-bundle-sdk .quantity__input"
      );
      let quantity =
        quantityInput && quantityInput.value
          ? parseInt(quantityInput.value, 10)
          : 1;
      // console.log('quantity: '+quantity);
      cartData.items[0].quantity = quantity;
      
      
      
      bundleVariantItems = subscriptionContainer.find('[data-name="bundle-item-variant-id"]');
      if(typeof bundleVariantItems != 'undefined' && bundleVariantItems.length && typeof window.__bundleSubscriptions != 'undefined' && window.__bundleSubscriptions){
        bundleVariantItems.each(function () {
          var bundleItemEle = jQuery(this);
          const bundleNewItem = JSON.parse(JSON.stringify(cartData.items[0]));
          var bundleItemEleId = bundleItemEle.val();
          if(bundleNewItem.id != bundleItemEleId){
            if (selling_plan_type != "one-time"){
              var bundleItemSubscriptions = window.__bundleSubscriptions[bundleItemEleId];
              bundleItemSubscriptions.forEach(function(bundleItemSubscription){
                if(bundleItemSubscription.id ==  _selectedSubscriptionGroupId){
                  var bundleItemEleSellingPlanId = bundleItemSubscription.selling_plans[0].id;
                  bundleNewItem.selling_plan = bundleItemEleSellingPlanId;
                }
              })
            }
            
            const originalId = bundleNewItem.id;
            bundleNewItem.id = bundleItemEleId;
            cartData.items.push(bundleNewItem);
          }
        })  
      }
      
      cartData.items.forEach(item => {
        var cart_item_has_free_shipping = false;
        if(typeof free_shipping != 'undefined' && (free_shipping === true || free_shipping === 'true')){
          item.properties._free_shipping = true;
        }
      })
      

  
      let _response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartData),
      });
  
      let responseData;
      if (_response.ok) {
        // Assuming the response is JSON
        responseData = await _response.json();
      } else {
        _this.find('[data-ele="response-message"]').html(_response.message);
        console.error("Network response was not ok:", _response.statusText);
        subscriptionContainer.removeClass("adding");
        _this.find(".loading-overlay__spinner").addClass("hidden");
        return;
      }
  
      var _cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      if (_cart.classList.contains("is-empty")) {
        _cart.classList.remove("is-empty");
      }
  
      _cart.renderContents(responseData);
      _initPrice();
      _renderTierBanner();
      subscriptionContainer.removeClass("adding");
      _this.find(".loading-overlay__spinner").addClass("hidden");
      jQuery('quick-add-modal').removeAttr('open');
      _add_remove_free_shipping();

   }
    else{
      _this.after('<p class="select-varient-error">Select an Option</p>');
    }
  }
);

// Update price tire banner based on cart updation
document.addEventListener('DOMContentLoaded', function () {
    // Subscribe to the cartUpdate event
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (event.source === 'cart-items') {
          _initPrice();
          _renderTierBanner();
          _add_remove_free_shipping();
        }
    });

    subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        console.log('variantChange UPDATE');
        jQuery('.select-varient-error').remove();
        var sectionId = event.data?.sectionId;
        var variantId = event.data?.variant?.id;
        var variant = event.data?.variant;
      
        var variantRadios = jQuery(`variant-radios[data-section="quickadd-${sectionId}"]`);
        if(typeof variantRadios == 'undefined' || variantRadios.length < 1 ){
          var variantRadios = jQuery(`variant-radios[data-section="${sectionId}"]`);    
        }

        var productInfoContainer = jQuery('[id^="ProductInfo-quickadd-template--"][id$="__main"]');
        if(typeof productInfoContainer == 'undefined' || productInfoContainer.length < 1 ){
          var productInfoContainer = jQuery('[id^="ProductInfo-template--"][id$="__main"]');
        }
      
        variantRadios.find('[data-ele="variant-out-of-stock-error"]').remove();
      
        if(typeof variant && variant.available == false){
          productInfoContainer.find('[data-ele="card-bundle-sdk"]').hide();
          productInfoContainer.find('[data-ele="BIS-notify-me"]').show();
          variantRadios.append('<p class="" data-ele="variant-out-of-stock-error">Flavor out of stock. Choose another flavor or click below to be notified when available.</p>');
        }else{
          productInfoContainer.find('[data-ele="card-bundle-sdk"]').show();
          productInfoContainer.find('[data-ele="BIS-notify-me"]').hide();
          
          if(variantId && sectionId){
            var compareAtPrice = event.data?.variant?.compare_at_price;
            var price = event.data?.variant?.price;
            
            if(variantRadios){
              variantRadios.parents('product-info').find('[data-name="variant-id"]').val(variantId);
              //variantRadios.parents('product-info').find('[data-ele="price_container"]').attr('data-plan-price',compareAtPrice);
              variantRadios.parents('product-info').find('[data-ele="price_container"]').attr('data-plan-sale-price',price);
              // optionType = variantRadios.parents('product-info').find('[data-ele="price_container"]').attr('price-container-type');
              // if(type of optionType != 'undefined' && optionType == 'subscription'){
              //   variantRadios.parents('product-info').find('[data-ele="price_container"]').parents('[data-ele="selling-plan-container"]').find('select[data-ele="subscription-options"]').option()
              // }

    
              try {
                // Ensure variantRadios exists and fetch the select element
                const selectElement = variantRadios
                  .closest('product-info')
                  .find('[data-ele="subscription-options"]');
              
                if (!selectElement.length) throw new Error("Select element not found");
              
                const options = selectElement.find("option"); // Get all options inside the select element

                variant.selling_plan_allocations.forEach((plan) => {
                  const { per_delivery_price, compare_at_price, selling_plan_id, selling_plan_group_id } = plan;
                  options.each(function () { // Use .each for jQuery iteration
                    const option = jQuery(this); // Wrap the current option with jQuery
                    if (
                      option.data("plan-selling-plan-id") == selling_plan_id &&
                      option.data("plan-selling-plan-group-id") == selling_plan_group_id
                    ) {
                      console.log('HERE');
                      console.log('selling_plan_id', selling_plan_id);
                      console.log('selling_plan_group_id', selling_plan_group_id);
                      console.log('================');
                      option.attr("data-plan-price", compare_at_price); // Update data-plan-price
                      option.attr("data-plan-sale-price", price); // Update data-plan-sale-price
                    }
                    option.attr("data-plan-price", price); // Update data-plan-price
                    option.attr("data-plan-sale-price", per_delivery_price); // Update data-plan-sale-price
                  });
                });
              } catch (error) {
                console.error("Error updating select attributes:", error.message);
              }
            }
          }
        _initPrice();
      }
    });

    subscribe(PUB_SUB_EVENTS.quickAddModalShow, function(event) {
      _initPrice();
      jQuery('[data-ele="back-to-cart"]').remove();
      if(jQuery('cart-drawer').hasClass('active')){
        setTimeout(function() {
            jQuery('quick-add-modal[open]').find('.quick-add-modal__toggle').before('<span class="backtocart" data-ele="back-to-cart">Back to cart</span>');
        }, 1000);
      }
      // jQuery('cart-drawer').removeClass('active');
      jQuery('cart-drawer').removeClass('active');
      initVariantDependencyHandler();
    });

    jQuery(document).on('click', '[data-ele="back-to-cart"]', function(){
      jQuery('quick-add-modal').removeAttr('open');
      jQuery('cart-drawer').addClass('active');
    });
});

const productRecommendations = document.querySelector('product-recommendations');
if (productRecommendations) {
  productRecommendations.addEventListener('product-recommendations:loaded', (event) => {
    if (event.detail.loaded) {
      _initPrice();
      _renderTierBanner();
    }
  });
}

function initVariantDependencyHandler(scope = document) {
  scope.querySelectorAll('product-info').forEach(function(productForm) {
    const variantDataEl = productForm.closest('[data-product-json-wrapper]')?.querySelector('[type="application/json"][data-product-json]') 
                          || productForm.querySelector('[type="application/json"][data-product-json]');
    if (!variantDataEl) return;

    const productData = JSON.parse(variantDataEl.textContent);
    if (!productData || !productData.variants || !productData.options) return;

    function updateOptions(changedOptionIndex) {
      const selectedValues = [];

      // Collect current selected values
      productData.options.forEach((optName, idx) => {
        const input = productForm.querySelector(`[name="options[${optName}]"]`);
        if (input?.tagName === "SELECT") {
          selectedValues[idx] = input.value;
        } else {
          const checked = productForm.querySelector(`[name="${optName}"]:checked`);
          selectedValues[idx] = checked ? checked.value : null;
        }
      });

      // Update subsequent options
      productData.options.forEach((optName, idx) => {
        if (idx <= changedOptionIndex) return;

        const inputEls = productForm.querySelectorAll(`[name="${optName}"]`);
        if (!inputEls.length) return;

        const possibleValues = new Set();
        productData.variants.forEach(variant => {
          let match = true;
          for (let checkIdx = 0; checkIdx < idx; checkIdx++) {
            if (selectedValues[checkIdx] && variant[`option${checkIdx + 1}`] !== selectedValues[checkIdx]) {
              match = false;
              break;
            }
          }
          if (match) {
            possibleValues.add(variant[`option${idx + 1}`]);
          }
        });

        if (inputEls[0].tagName === "SELECT") {
          inputEls[0].querySelectorAll("option").forEach(opt => {
            opt.hidden = opt.value && !possibleValues.has(opt.value);
          });

          if (inputEls[0].selectedOptions[0]?.hidden) {
            const firstAvailable = [...inputEls[0].options].find(o => !o.hidden);
            if (firstAvailable) {
              inputEls[0].value = firstAvailable.value;
              inputEls[0].dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        } else {
          inputEls.forEach(el => {
            el.disabled = !possibleValues.has(el.value);
          });
        }
      });
    }

    // Event listeners
    productData.options.forEach((optName, idx) => {
      const inputs = productForm.querySelectorAll(`[name="${optName}"]`);
      inputs.forEach(input => {
        input.addEventListener('change', () => updateOptions(idx));
      });
    });

    // Initial run
    updateOptions(0);
  });
}

// Run on page load
document.addEventListener("DOMContentLoaded", function() {
  initVariantDependencyHandler();
});


document.querySelectorAll('[data-ele="price"]').forEach(priceEl => {
  const shouldRemove = priceEl.getAttribute('data-ele-remove-decimal-points') === 'true';
  if (!shouldRemove) return;

  // Select all price display elements inside this price block
  const priceItems = priceEl.querySelectorAll('.price-item');

  priceItems.forEach(item => {
    let text = item.textContent.trim();
    let dataPrice = item.getAttribute('data-price');

    // Function to remove decimal points (e.g., $25.00 → $25)
    const removeDecimals = value =>
      //value.replace(/(\d+)\.00/g, '$1');    // Remove .00
      value.replace(/(\d+)\.\d+/g, '$1');

      // If you want to remove ANY decimals like .50, use:  value.replace(/(\d+)\.\d+/g, '$1');

    // Update visible text
    if (text) {
      item.textContent = removeDecimals(text);
    }

    // Update data-price attribute
    if (dataPrice) {
      item.setAttribute('data-price', removeDecimals(dataPrice));
    }
  });
});
